/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForGcpParentBillingAccount extends models.ServiceAccountNativeDetailsBaseForGcp {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForGcpParentBillingAccount");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForGcpParentBillingAccount.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForGcpParentBillingAccount>): ServiceAccountNativeDetailsForGcpParentBillingAccount {
        let obj = Object.assign(new ServiceAccountNativeDetailsForGcpParentBillingAccount(), model);
        ServiceAccountNativeDetailsForGcpParentBillingAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForGcpParentBillingAccount>): ServiceAccountNativeDetailsForGcpParentBillingAccount {
        if (!model) return null;
        return ServiceAccountNativeDetailsForGcpParentBillingAccount.newInstance(<ServiceAccountNativeDetailsForGcpParentBillingAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForGcpParentBillingAccount) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForGcpParentBillingAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForGcpParentBillingAccount): boolean {
        if (models.ServiceAccountNativeDetailsBaseForGcp.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForGcpParentBillingAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Billing Account Id
     */
    billing_account_id: string;

}
